namespace RioERP.Wallet {
    export interface CreditWalletRow {
        Id?: number;
        JournalId?: string;
        AssetTypeId?: number;
        Credits?: number;
        CreditBalance?: number;
        TransactionId?: number;
        TransactionDate?: string;
        TransactionDetails?: string;
        TransactionNo?: string;
        FranchiseeId?: number;
        JournalName?: string;
        JournalDescription?: string;
        JournalKind?: number;
        FranchiseeName?: string;
        FranchiseeDescription?: string;
        FranchiseeEmail?: string;
        FranchiseeAlternateEmail?: string;
        FranchiseeMobile?: string;
        FranchiseeAlternateMobile?: string;
        FranchiseeAddress?: string;
        FranchiseeCity?: string;
        FranchiseeStateId?: number;
        FranchiseeUserId?: number;
        FranchiseeGstin?: string;
        FranchiseePan?: string;
        FranchiseeGstCertificate?: string;
        FranchiseeBankName?: string;
        FranchiseeBankAccountType?: number;
        FranchiseeBankAccountName?: string;
        FranchiseeBankAccountNo?: string;
        FranchiseeBankIfscCode?: string;
        FranchiseePincode?: number;
        FranchiseeIsActive?: boolean;
        FranchiseeInsertUserId?: number;
        FranchiseeInsertDate?: string;
        FranchiseeUpdateUserId?: number;
        FranchiseeUpdateDate?: string;
        FranchiseeIsCustomer?: boolean;
        FranchiseeCustomerId?: number;
        FranchiseeDiscountCoupon?: string;
        FranchiseeIsPostPayAllowed?: boolean;
        FranchiseeAffiliateId?: string;
    }

    export namespace CreditWalletRow {
        export const idProperty = 'Id';
        export const nameProperty = 'JournalId';
        export const localTextPrefix = 'Wallet.CreditWallet';
        export const deletePermission = 'Wallet:WalletManagement:Modify';
        export const insertPermission = 'Wallet:WalletManagement:Modify';
        export const readPermission = 'Wallet:WalletManagement:View';
        export const updatePermission = 'Wallet:WalletManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            JournalId = "JournalId",
            AssetTypeId = "AssetTypeId",
            Credits = "Credits",
            CreditBalance = "CreditBalance",
            TransactionId = "TransactionId",
            TransactionDate = "TransactionDate",
            TransactionDetails = "TransactionDetails",
            TransactionNo = "TransactionNo",
            FranchiseeId = "FranchiseeId",
            JournalName = "JournalName",
            JournalDescription = "JournalDescription",
            JournalKind = "JournalKind",
            FranchiseeName = "FranchiseeName",
            FranchiseeDescription = "FranchiseeDescription",
            FranchiseeEmail = "FranchiseeEmail",
            FranchiseeAlternateEmail = "FranchiseeAlternateEmail",
            FranchiseeMobile = "FranchiseeMobile",
            FranchiseeAlternateMobile = "FranchiseeAlternateMobile",
            FranchiseeAddress = "FranchiseeAddress",
            FranchiseeCity = "FranchiseeCity",
            FranchiseeStateId = "FranchiseeStateId",
            FranchiseeUserId = "FranchiseeUserId",
            FranchiseeGstin = "FranchiseeGstin",
            FranchiseePan = "FranchiseePan",
            FranchiseeGstCertificate = "FranchiseeGstCertificate",
            FranchiseeBankName = "FranchiseeBankName",
            FranchiseeBankAccountType = "FranchiseeBankAccountType",
            FranchiseeBankAccountName = "FranchiseeBankAccountName",
            FranchiseeBankAccountNo = "FranchiseeBankAccountNo",
            FranchiseeBankIfscCode = "FranchiseeBankIfscCode",
            FranchiseePincode = "FranchiseePincode",
            FranchiseeIsActive = "FranchiseeIsActive",
            FranchiseeInsertUserId = "FranchiseeInsertUserId",
            FranchiseeInsertDate = "FranchiseeInsertDate",
            FranchiseeUpdateUserId = "FranchiseeUpdateUserId",
            FranchiseeUpdateDate = "FranchiseeUpdateDate",
            FranchiseeIsCustomer = "FranchiseeIsCustomer",
            FranchiseeCustomerId = "FranchiseeCustomerId",
            FranchiseeDiscountCoupon = "FranchiseeDiscountCoupon",
            FranchiseeIsPostPayAllowed = "FranchiseeIsPostPayAllowed",
            FranchiseeAffiliateId = "FranchiseeAffiliateId"
        }
    }
}
